import type { IValidatorParams } from "@edaz/services/baseValidationService";

export type IsNotEqualOptions = IsNotEqualOptions1 | IsNotEqualOptions2;

interface IsNotEqualOptions1 {
  condition: (entity: any) => string | undefined;
  notEqual?: undefined;
}

interface IsNotEqualOptions2 {
  condition?: undefined;
  notEqual: string;
}

export default function isNotEqual(value: Date | undefined, options: IsNotEqualOptions, params?: IValidatorParams) {
  if (value) {
    if (options.notEqual) {
      return value?.toString().trim() !== options.notEqual.toString().trim();
    } else if (options.condition) {
      const notEqual = options.condition(params?.entity);
      if (notEqual) {
        return value?.toString().trim() !== notEqual.toString().trim();
      }
    }
  }

  return true;
}
